import { keywordRows } from "@/mocks/homeData";

export default function SearchGuide() {
  return (
    <section id="search" className="w-full scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold tracking-[0.2em] text-accent-700">SEARCH / 搜索技巧</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            搜索技巧与关键词组合
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            同样的作品，换一组关键词，往往能得到完全不同质量的结果。下表整理了常见的搜索意图，
            以及每种意图下更合适的处理方式。
          </p>
        </div>

        <div className="mt-10 overflow-hidden rounded-xl border border-background-200">
          <div className="hidden grid-cols-12 gap-4 bg-background-100 px-6 py-4 text-xs font-medium tracking-wide text-foreground-500 md:grid">
            <span className="col-span-4">搜索关键词</span>
            <span className="col-span-3">用户意图</span>
            <span className="col-span-5">建议做法</span>
          </div>

          <div className="divide-y divide-background-200 bg-background-50">
            {keywordRows.map((row) => (
              <div
                key={row.keyword}
                className="grid grid-cols-1 gap-2 px-5 py-5 transition-colors hover:bg-background-100 md:grid-cols-12 md:gap-4 md:px-6"
              >
                <div className="md:col-span-4">
                  <span className="mb-1 block text-[11px] text-foreground-400 md:hidden">搜索关键词</span>
                  <span className="inline-flex items-center gap-2 font-medium text-foreground-900">
                    <i className="ri-search-line text-accent-600"></i>
                    {row.keyword}
                  </span>
                </div>
                <div className="md:col-span-3">
                  <span className="mb-1 block text-[11px] text-foreground-400 md:hidden">用户意图</span>
                  <span className="text-sm text-foreground-600">{row.intent}</span>
                </div>
                <div className="md:col-span-5">
                  <span className="mb-1 block text-[11px] text-foreground-400 md:hidden">建议做法</span>
                  <span className="text-sm leading-relaxed text-foreground-700">{row.advice}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
          <div className="rounded-xl border border-background-200 bg-background-100 p-5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className="ri-add-line"></i>
            </span>
            <h3 className="mt-4 text-sm font-semibold text-foreground-900">加上限定词</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
              在标题后补充“年份”“平台名”等限定词，能显著减少无关结果。
            </p>
          </div>
          <div className="rounded-xl border border-background-200 bg-background-100 p-5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-800">
              <i className="ri-filter-3-line"></i>
            </span>
            <h3 className="mt-4 text-sm font-semibold text-foreground-900">变换组合方式</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
              “在哪看”“资源”“入口”轮换使用，不同词会命中不同整理帖。
            </p>
          </div>
          <div className="rounded-xl border border-background-200 bg-background-100 p-5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
              <i className="ri-history-line"></i>
            </span>
            <h3 className="mt-4 text-sm font-semibold text-foreground-900">留意更新时间</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
              优先选择近期更新的页面，过老的整理帖大多已经失效。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}